{
  "R": [0, 0, 0, 0, 196, 255],
  "G": [0, 32, 128, 128, 128, 32],
  "B": [0, 255, 196, 0, 0, 0],
  "A": [0, 128, 64, 64, 64, 128],
  "I": [0, 1, 64, 128, 192, 255]
}
